import { Fragment, useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import download from "downloadjs";
import numeral from "numeral";

import MergerUpload from "./MergerUpload";
import ShareEditImage from "../ShareEditImage/ShareEditImage";
import ImageFileNameChange from "../ImageFileNameChange/ImageFileNameChange";
import ImageFileUpload from '../ImageFileUpload/ImageFileUpload';

import { useStore } from "../../hook-store/store";

import { loginPageLink, signupPageLink } from "../../App";

import { marks } from "../../utils/marks";
import './ImageMerger.css';

export default function MergerResult(props) {
  const { 
    // combinedB64String,
    // combinerInputFiles,
    inputFiles,
    mergedFile,
    setMergedFile,
  } = props;

  const [t] = useTranslation('translation');

  const [store, dispatch] = useStore();
  const { isAuth } = store.uiStore;

  const [showNameChangeModal, setShowNameChangeModal] = useState(false);
  const [showInputUploadModal, setShowInputUploadModal] = useState(false);
  const [showOutputFull, setShowOutputFull] = useState(false);


  const fileDownloadHandler = (file) => {
    // const fileData = resizedFileString.split(";")[0];
    // const fileType = fileData.split(":")[1];
    // const fileName = `combine-${Date.now()}.${fileType.split("/")[1]}`;

    download(file, file.name, file.type);
  };


  const createShareFileHandler = () => {
    return mergedFile;
  }


  const fileNameUpdateHandler = (file) => {
    // setCombinedFile(file);
    setMergedFile(file);
  };


  let outputStyle = {
    maxHeight: '400px',
    maxWidth: '100%',
    objectFit: 'scale-down',
    border: "1px dashed gray",
  };

  if (showOutputFull) {
    outputStyle = null;
  }

  return (
    <Fragment>
      {mergedFile && (
        <div>
          <section className="mergerSectoin">
            <img
              // className="resizerImage"
              style={outputStyle}
              //   title={item.file.name}
              src={URL.createObjectURL(mergedFile)}
              alt="for resize"
              onClick={() => {}}
              // onLoad={getCombineDimension}
            />
            <div>
              <div>
                <span
                  onClick={() => {
                    setShowOutputFull(!showOutputFull);
                  }}
                >
                  {showOutputFull && (
                    <span>
                      {t('imageMerger19', 'Fit screen')}
                    </span>
                  )}
                  {!showOutputFull && (
                    <span>
                      {t('imageMerger20', 'Display full size')}
                    </span>
                  )}
                </span>
              </div>
            </div>
          </section>

            
          <div className="mergerSectoin">
            <div>{t('combiner16', 'File name')}</div>
            <div>
              {mergedFile.name} ({numeral(mergedFile.size).format('0.0 b')})
            </div>
          </div>

          <div className="">
            <button
              className="btnBase"
              onClick={() => {
                setShowNameChangeModal(true);
              }}
            >
              {t('fileAction.06', 'Change Name')}
            </button>
          </div>
          {showNameChangeModal && (
            <div className="mergerSectoin">
              <ImageFileNameChange 
                currentRenderFile={mergedFile}
                createUploadFile={fileNameUpdateHandler}
                onClose={() => { setShowNameChangeModal(false); }}
              />
            </div>
          )}
          <div className="mergerSectoin"></div>
          <div className="mergerSectoin"></div>
          <div className="mergerSectoin"></div>
        


          <div className="mergerActionButtons">
            <button className="btnBase"
              onClick={() => {
                // fileDownloadHandler(combinedB64String);
                fileDownloadHandler(mergedFile);
              }}
            >
              {marks.downloadMark} {t('combiner08', 'Download')}
            </button>

            <MergerUpload
              combinedB64String={''}
              combinedFile={mergedFile}
            />

            {/* <ShareEditImage
              createShareFile={createShareFileHandler}
              fileForShare={mergedFile}
            /> */}
          </div>

          <div className='imageConvertElement'>
              <button className='btnBase'
                disabled={!inputFiles.length === 0}
                onClick={() => {
                  setShowInputUploadModal(true);
                }}
              >
                {marks.uploadMark} {t('combiner17', 'Upload input files')}
              </button>
          
              {showInputUploadModal && (
                <ImageFileUpload 
                  files={inputFiles}
                  onClose={() => { 
                    setShowInputUploadModal(false) 
                  }}
                  uploadApp={'imageMerger'}
                />
              )}
            </div>
        </div>
      )}

      {!isAuth && (
        <div>
          <p>
            {t('aboutPage.09', 'Login to upload and store files, or create account')}
          </p>

          <div className="resizerResizeLoginButtons">
            <a href={loginPageLink}>
              <button className="btnBase">
                {marks.signInMrak} {t('aboutPage.10', 'Login')}
              </button>
            </a>
            <span> {t('aboutPage.11', 'or')} </span>
            <a href={signupPageLink}>
              <button className="btnBase">
                {marks.userPlusMrak} {t('aboutPage.12', 'Signup')}
              </button>
            </a>
          </div>
        </div>
      )}
    </Fragment>
  );
}
